























































































































































import { Vue, Component } from 'vue-property-decorator';
import Uploader from '../components/NewUploader.vue';
import Uploader1 from '../components/NewUploader1.vue';
import Uploader2 from '../components/NewUploader2.vue';
import { cover, cardList, nowPrize, checkUserExist } from '../api';
import { FileType } from '@/common/ts/enum';
import { isWeiXin } from '@/common/ts/common';
import { unionIdIsBind } from '@/api/api';
import { Toast, Popup } from 'vant';
import qs from 'qs';
Vue.use(Popup);
@Component({
  components: {
    Uploader,
    Uploader1,
    Uploader2,
  },
})
export default class Home extends Vue {
  c1show: boolean = true;
  c2show: boolean = true;
  c3show: boolean = true;
  cover1: any[] = [];
  cover2: any[] = [];
  cover3: any[] = [];
  imageMaxSize = 10;
  imageMinSize = 0;
  maxImage = 3;
  activity: number = 0;
  tab: any = [{ text: '小份菜' }, { text: '光盘有奖' }, { text: '文明行为' }];
  classOption: any = { limitMoveNum: 1, direction: 2, step: 1 };
  titleCoverList: any[] = [];
  mounted() {
    this.intoact();
    nowPrize().then((res: any) => {
      if (res.code === 200) {
        this.titleCoverList = res.data;
      }
    });
    const unionId = window.localStorage.getItem('unionid');
    cardList(unionId + '').then((res: any) => {
      if (res.code === 200) {
        if (res.data.small.length > 0) {
          if (res.data.small.length >= 3) {
            this.c1show = false;
          }
          res.data.small.forEach((item: any) => {
            this.cover1.push({
              cover: item.cover,
              path: item.cover,
              type: FileType.Image,
            });
          });
        }
        if (res.data.light.length > 0) {
          if (res.data.light.length >= 3) {
            this.c2show = false;
          }
          res.data.light.forEach((item1: any) => {
            this.cover2.push({
              cover: item1.cover,
              path: item1.cover,
              type: FileType.Image,
            });
          });
        }
        if (res.data.civilization.length > 0) {
          if (res.data.civilization.length >= 3) {
            this.c3show = false;
          }
          res.data.civilization.forEach((item2: any) => {
            this.cover3.push({
              cover: item2.cover,
              path: item2.cover,
              type: FileType.Image,
            });
          });
        }
      } else if (res.code === 203) {
        this.intoact();
      }
    });
  }
  intoact() {
    const unionId = window.localStorage.getItem('unionid');
    console.log(unionId);
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      this.$router.push('home');
    } else if (!unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    } else {
      checkUserExist(unionId + '').then((res: any) => {
        console.log(res.data);
        if (!res.data) {
          this.$router.push('citysort');
        }
      });
    }
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  changeActivity(index: any) {
    this.activity = index;
  }
  intoLuckDraw() {
    this.$router.push('luckdraw');
  }
  async upCover1() {
    const cover1 = (await (this.$refs
      .uploaderImage1 as Uploader).uploadToOss()) as string[];
    const unionid1 = window.localStorage.getItem('unionid');
    if (cover1.length > 0) {
      const paths = cover1.join('|');
      const data = {
        unionid: unionid1,
        cover: paths,
        workType: 1,
      };
      cover(data).then((res: any) => {
        Toast(res.msg);
        window.location.reload();
      });
    }
  }
  async upCover2() {
    const cover2 = (await (this.$refs
      .uploaderImage2 as Uploader1).uploadToOss()) as string[];
    const unionid1 = window.localStorage.getItem('unionid');
    if (cover2.length > 0) {
      const paths = cover2.join('|');
      const data = {
        unionid: unionid1,
        cover: paths,
        workType: 2,
      };
      cover(data).then((res: any) => {
        Toast(res.msg);
        window.location.reload();
      });
    }
  }
  async upCover3() {
    const cover3 = (await (this.$refs
      .uploaderImage3 as Uploader2).uploadToOss()) as string[];
    const unionid1 = window.localStorage.getItem('unionid');
    if (cover3.length > 0) {
      const paths = cover3.join('|');
      const data = {
        unionid: unionid1,
        cover: paths,
        workType: 3,
      };
      cover(data).then((res: any) => {
        Toast(res.msg);
        window.location.reload();
      });
    }
  }
}
